import { render, staticRenderFns } from "./DialogContact.vue?vue&type=template&id=15b4ab5e&"
import script from "./DialogContact.vue?vue&type=script&lang=js&"
export * from "./DialogContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports